import React, { useState, useEffect } from 'react'

import { ContentsRenderSection } from 'components/AssetManager';
import AssetUploader from 'components/AssetManager/assetUploader';
import StoryboardContext from 'components/Storyboard/context';

import styles from './contentManager.module.scss';

export const ContentManagerSettings = ({storyboard}) => {

  return (
    <>
      <div className={styles.managerSettingsContent}>
        <header className={styles.header}>
          <div className={styles.detail}>
            <div className={styles.title}>Content Manager</div>
            <div className={styles.description}>A telescopic view of all your content</div>
          </div>
          <AssetUploader handleViewChange={()=>{console.log('change')}}/>
        </header>
        <section className={styles.tabContainer}>
          <div className={styles.wrapper}>
            <ContentsRenderSection edit={true} uploadingAsset={false} storyboard={storyboard} />
          </div>
        </section>
      </div>
    </>
  )
}
